import React, { useState } from "react";

const AddDataModal = ({ isOpen, onClose, onSubmit, studentId, courseId }) => {
  const [formData, setFormData] = useState({
    enrollment_date: "",
    payment_method: "",
    amount_paid: "",
    description: "",
  });

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      student: studentId,
      course: courseId,
      fee: 1, // Assuming fee is always 1
      payment_method: formData.payment_method,
      amount_paid: parseFloat(formData.amount_paid),
      enrollment_date: formData.enrollment_date,
      description: formData.description,
    });
    onClose(); // Close the modal after submission
  };

  if (!isOpen) return null;

  // Internal CSS
  const styles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "8px",
      width: "400px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    formGroup: {
      marginBottom: "15px",
    },
    formGroupLabel: {
      display: "block",
      marginBottom: "5px",
      fontWeight: "semi-bold",
      fontSize: '14px'
    },
    formGroupInput: {
      width: "100%",
      padding: "8px",
      boxSizing: "border-box",
      borderRadius: "4px",
      border: "1px solid #ccc",
    },
    formActions: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
    },
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <h4 className="mb-3">Add New Data</h4>
        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.formGroupLabel}>Enrollment Date</label>
            <input
              type="date"
              name="enrollment_date"
              value={formData.enrollment_date}
              onChange={handleChange}
              required
              style={styles.formGroupInput}
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.formGroupLabel}>Payment Method</label>
            <select
              name="payment_method"
              value={formData.payment_method}
              onChange={handleChange}
              required
              style={styles.formGroupInput}
            >
              <option value="">Select Payment Method</option>
              <option value="Cash">Cash</option>
              <option value="E-Bank">E-Bank</option>
            </select>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.formGroupLabel}>Amount Paid</label>
            <input
              type="number"
              name="amount_paid"
              value={formData.amount_paid}
              onChange={handleChange}
              required
              style={styles.formGroupInput}
            />
          </div>
          <div>
            <label style={styles.formGroupLabel}>Description</label>
            <textarea className="w-100 mb-3" name="description" rows={3} id=""
              value={formData.description}  onChange={handleChange}></textarea>
          </div>
          <div style={styles.formActions}>
            <button
              type="button"
              onClick={onClose}
              className="btn bg-secondary text-white"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-success text-white"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDataModal;